import { FETCH_FASTAG_PROVIDER } from '@constants/fastagConstants'
import { errorWithStack } from '@utils/logger'

export const fastagBillerService = async (setIsFetchingProvider): Promise<any> => {
  try {
    const response = await fetch(FETCH_FASTAG_PROVIDER)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    // Return the fetched data
    setIsFetchingProvider(false)
    return data?.data
  } catch (err) {
    setIsFetchingProvider(false)
    errorWithStack('Error fetching Fastag providers', err)
    return null // Return null or handle error as needed
  }
}
